import React, { useState, useRef } from "react";
import Select, { components } from "react-select";
import DateRange from "../../../Component/DateRange/DateRange";
import { post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { Toast } from "../../../Component/Toast";

const DeleteData = () => {
  const selectRef = useRef(null);

  const [menuOpen, setMenuOpen] = useState(false);

  /** FINAL VALUE (INPUT DISPLAY) */
  const [selected, setSelected] = useState([]);

  /** TEMP VALUE (CHECKBOX STATE) */
  const [tempSelected, setTempSelected] = useState([]);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const options = [
    { value: "Sales", label: "Sales Report" },
    { value: "Recharges", label: "Recharge History" },
    { value: "Withdraws", label: "Withdraw History" },
    { value: "Commissions", label: "Commission History" },
    { value: "Wallet Transactions", label: "Wallet Transactions" },
  ];

  const styles = {
    control: (base) => ({
      ...base,
      minHeight: 50,
      borderRadius: 8,
      backgroundColor: "#F0EDE6",
      border: "1px solid #00474366",
      boxShadow: "none",
    }),

    menu: (base) => ({
      ...base,
      backgroundColor: "#F0EDE6",   // ✅ dropdown background
      borderRadius: 8,
      marginTop: 4,
      zIndex: 9999,
    }),

    menuList: (base) => ({
      ...base,
      backgroundColor: "#F0EDE6",   // ✅ options container
      padding: 0,
      borderRadius: 8,
    }),

    option: () => ({
      padding: 0,
      borderRadius: 8,// we control padding inside custom option
    }),

    indicatorSeparator: () => ({ display: "none" }),
  };


  /* ---------- CHECKBOX OPTION ---------- */
  const CheckboxOption = ({ data, isSelected, innerRef }) => (
    <div
      ref={innerRef}
      onClick={(e) => {
        e.stopPropagation();
        setTempSelected((prev) =>
          prev.some((x) => x.value === data.value)
            ? prev.filter((x) => x.value !== data.value)
            : [...prev, data]
        );
      }}
      style={{
        display: "flex",
        alignItems: "center",
        padding: "10px 12px",
        cursor: "pointer",
        backgroundColor: isSelected ? "#00474335" : "#F0EDE6",
        color: "#004743",
      }}
    >
      <input type="checkbox" style={{ accentColor: "#004743", }} checked={isSelected} readOnly />
      <span style={{ marginLeft: 10 }}>{data.label}</span>
    </div>
  );

  /* ---------- MENU WITH OK ---------- */
  const Menu = (props) => (
    <components.Menu {...props}>
      {props.children}
      <div style={{ padding: 10, borderTop: "1px solid #ddd", background: "#F0EDE6", borderRadius: 8, }}>
        <button
          className="add-button w-100"
          onClick={() => {
            setSelected(tempSelected); // APPLY
            setMenuOpen(false);        // CLOSE
          }}
        >
          OK
        </button>
      </div>
    </components.Menu>
  );

  const handleDelete = async () => {
    if (!fromDate || !toDate) return Toast("Select date range");
    if (!selected.length) return Toast("Select at least one type");

    setLoading(true);
    try {
      await post(URLS.DELETEDATA, {
        start_date: fromDate,
        end_date: toDate,
        types: selected.map((x) => x.value),
        delete_after_export: true,
      });
      Toast("Deleted successfully");
      setPopup(false);
    } catch {
      Toast("API Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashRightView">
      <div className="container_overall containers_list">

        {/* MULTI SELECT */}
        <div className="col-md-5 my-3">
          <Select
            ref={selectRef}
            options={options}
            isMulti
            menuIsOpen={menuOpen}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            isSearchable={false}
            styles={styles}
            value={menuOpen ? tempSelected : selected}

            placeholder="Select"
            components={{ Option: CheckboxOption, Menu }}

            onMenuOpen={() => {
              setTempSelected(selected);
              setMenuOpen(true);
            }}

            onMenuClose={() => {
              setSelected(tempSelected);
              setMenuOpen(false);
            }}
          />
        </div>

        <DateRange
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />

        <div className="my-4 col-md-5">
          <button onClick={() => setPopup(true)} className="add-button w-100">
            Delete
          </button>
        </div>

        {popup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p>Are you sure?</p>
              <div className="d-flex ac-jb pt-3">
                <button className="no-btn w-45" onClick={() => setPopup(false)}>
                  No
                </button>
                <button className="yes-btn w-45" onClick={handleDelete}>
                  {loading ? <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white" }}
                    ></span>
                  </> : 'Yes'}
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default DeleteData;
